module.exports = __webpack_public_path__ + "img/1529828019.744957d9.jpg";